import {
    Box,
    Button,
    Dialog,
    IconButton,
    Theme,
    Typography
} from "@mui/material";
import { BlackExitIcon } from "../../../assets/SvgIcons";
import CustomTable from "../common/customTable";
import MutualFundTableBody from "../common/customTable/MutualFundTableBody";
import {
    Order,
    SortingObj,
    TableBodyData,
    TableHeaderData
} from "../types";
import { useHistory } from "react-router";
import { RootStateType } from "../../../redux-store/reducers";
import { useSelector } from "react-redux";
import { isModuleAllowed } from "../../../utils/utilityFunctions";
import { USER_ROLES } from "../../../utils/constant";


interface SelectedSchemesDialogProps {
    isVisible: boolean;
    onClose: () => void;
    tableData: TableBodyData[],
    sortingObj: SortingObj;
    setSortingObj: ({ order, orderBy }: SortingObj) => void
    onCheckboxClick: (schemeId: string, checked: boolean) => void
    onSchemeClick: (schemeObj: TableBodyData) => void
    clientCode: string
    selectedCategory?: string
}

export default function SelectedSchemesDialog({
    isVisible,
    onClose,
    tableData,
    sortingObj,
    setSortingObj,
    onCheckboxClick,
    onSchemeClick,
    clientCode,
    selectedCategory = ""
}: SelectedSchemesDialogProps): JSX.Element {
    const history = useHistory()
    const { pathname: pathName } = history.location

    const {
        role = '',
        permissions = []
    } = useSelector((store: RootStateType) => store.auth);
    const {
        bseTxnStatus
    } = useSelector((store: RootStateType) => store.selectedPortfiolio);

    const headersForNfo = [
        { id: "issueOpen", label: "NFO Start Date", align: "center", isSortable: false },
        { id: "issueStatedClose", label: "NFO End Date", align: "center", isSortable: false },
    ] satisfies readonly TableHeaderData[];

    const headersForNormal = [
        // { id: "intFundRating", label: "Ratings", align: "center", isSortable: true },
        { id: "year1Return", label: "1Y Returns", align: "center", isSortable: true },
        { id: "year3Return", label: "3Y Returns", align: "center", isSortable: true },
        { id: "year5Return", label: "5Y Returns", align: "center", isSortable: true },
    ] satisfies readonly TableHeaderData[];

    const tableHeaderData: TableHeaderData[] = [
        { id: "schemeName", label: "SCHEME", align: "left", isSortable: true },
        ...(selectedCategory === "NFO" ? headersForNfo : headersForNormal),
    ];

    const handleRecommendClick = () => {
        onClose()

        const selectedSchemes = tableData.filter(obj => obj.checked)

        const schemeDetails = selectedSchemes?.map((obj: TableBodyData) => {
            return {
                scheme_id: obj?.scheme ?? "-",
                isReinvestment: obj?.divReinvestAllowed ?? "-"
            }
        })

        history.push(`${pathName}/investment-details`, { selectedSchemes, clientCode, schemeDetails, selectedCategory })
    }

    return (
        <Dialog
            onClose={onClose}
            open={isVisible}
            maxWidth='lg'
            fullWidth
            sx={(theme: Theme) => ({
                '& .MuiPaper-root': {
                    borderRadius: '25px',
                    backgroundColor: theme.palette.common.white,
                    padding: "35px",
                    boxShadow: `0px 4px 10px 0px ${theme.palette.common.black}0D`
                },
            })}
        >
            <Box
                sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "flex-start",
                }}
            >
                <Typography
                    variant="h3"
                    sx={(theme: Theme) => ({
                        color: theme.palette.text.primary
                    })}
                >
                    Selected Schemes
                </Typography>
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        padding: "5px"
                    }}
                >
                    <BlackExitIcon />
                </IconButton>
            </Box>
            <Box
                sx={{
                    marginTop: "20px",
                    maxHeight: "538px",
                    overflowY: "auto"
                }}
            >
                <CustomTable
                    tableBody={
                        <MutualFundTableBody
                            tableBodyData={tableData}
                            tableBodyRowCustomStyles={{
                                '& td:first-of-type': {
                                    paddingLeft: "0px"
                                },
                            }}
                            handleCheckboxClick={onCheckboxClick}
                            handleSchemeClick={onSchemeClick}
                        />
                    }
                    tableData={tableData}
                    tableHeaderData={tableHeaderData}
                    handleSort={
                        (orderBy: string, order: Order) =>
                            setSortingObj({
                                order,
                                orderBy
                            })
                    }
                    isPaginationVisible={false}
                    tableHeadRowCustomStyles={{
                        '& th:first-of-type': {
                            paddingLeft: "0px"
                        }
                    }}
                    tableBodyCustomStyles={{
                        '& tr:last-child td': {
                            border: 0
                        }
                    }}
                    loadingRowsNum={5}
                    tableDataCount={tableData.length}
                    order={sortingObj.order}
                    orderBy={sortingObj.orderBy}
                />
            </Box>
            <Box
                sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    marginTop: "15px"
                }}
            >
                <Button
                    onClick={handleRecommendClick}
                    variant="contained"
                    sx={(theme: Theme) => ({
                        borderRadius: "10px",
                        padding: "8px 55px",
                        backgroundColor: theme.palette.primary[500],
                        color: theme.palette.textDark.primary,
                        "&.Mui-disabled": {
                            backgroundColor: `${theme.palette.text.secondary}B2`,
                            color: theme.palette.text.secondary,
                        },
                        ...theme.typography.subtitle_500
                    })}
                    disabled={
                        tableData.every(obj => !obj.checked) ||
                        (
                            !isModuleAllowed({ value: 'MFOrders', compareArr: permissions, objKey: "permissonCode" }) &&
                            !isModuleAllowed({ value: 'OrderRecommend', compareArr: permissions, objKey: "permissonCode" })
                        ) ||
                        !bseTxnStatus
                    }
                >
                    {/* {![USER_ROLES.INVESTOR].includes(role) ? "Recommend" : "Proceed"} */}
                    Proceed
                </Button>
            </Box>
        </Dialog >
    )
}